import { Text } from '@dixa/lib-shared-habla';
import { colors } from '@dixa/lib-shared-tokens/index';

type ChannelCounterProps = {
  count: number;
  limit: number;
};
export const CharacterLimitIndicator = ({
  count,
  limit,
}: ChannelCounterProps): JSX.Element | null => {
  const shouldShowWarning = count >= limit * 0.9;

  return (
    <Text.Paragraph
      variant="3"
      color={shouldShowWarning ? colors.orange[400] : undefined}
    >
      {`${count}/${limit}`}
    </Text.Paragraph>
  );
};
